/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackViewModel } from "../types/FeedbackViewModel.ts";
import { eFeedbackTypeSchema } from "./eFeedbackTypeSchema.ts";

export const feedbackViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  title: z.string().nullish(),
  feedbackType: z.optional(
    z
      .lazy(() => eFeedbackTypeSchema)
      .describe("1 = Numeric | 2 = LikeAndDislike | 3 = LikeOnly | "),
  ),
  feedbackTypeText: z.string().nullish(),
  maxNumber: z.number().int().nullish(),
  allowMultipleAnswer: z.optional(z.boolean()),
  isGlobal: z.optional(z.boolean()),
  showComment: z.boolean().nullish(),
  companyId: z.number().int().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<FeedbackViewModel>;
